import React, { useState, useEffect } from 'react';
import {
  Form,
  Card,
  Select,
  Row,
  Col,
  Input,
  Spin,
  message,
  Image,
  DatePicker,
  Space
} from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllContainers,
  createSampling,
  getPastSamplingDetails,
  getsamples
  // updateSampling
} from '../../redux/slice';
import {
  getAllDispenseBooths,
  getBalance
} from '@/features/dispensing/redux/slice';
import CustomTable from 'common/Content/CustomTable';
import moment from 'moment';
import CustomButton from '@/common/CustomButton';
import {
  QrcodeOutlined,
  EditOutlined,
  DeleteOutlined
} from '@ant-design/icons';
import { QrReader } from 'react-qr-reader';
import { history } from 'app/history';
import { useLocation } from 'react-router-dom';
import { getLoggedInUser } from 'utilities/helpers';
import truck from '@/features/qa/components/images/truck-delivery-done.gif';
import VerificationModal from '@/features/material/components/VerificationModal';

const { TextArea } = Input;
const SamplingMaterialsPage = () => {
  const dateFormat = 'DD-MMM-YYYY';

  const [form] = Form.useForm();
  const searchParam = useLocation().search;
  const searchParams = new URLSearchParams(searchParam);
  const { allMaterials } = useSelector((state) => state.stocks);
  const { user } = getLoggedInUser();

  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const [containers, setContainers] = useState([]);

  const [openCam, setOpenCam] = useState(false);
  const [containerDetails, setContainerDetails] = useState([]);
  const [pastData, setPastData] = useState([]);
  const [containerChange, setContainerChange] = useState(false);
  const [isEdit, setIsEdit] = useState(true);
  const [truckShow, setTruckShow] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [sampleData, setSampleData] = useState({});
  const [samplingData, setSamplingData] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [dispenseBooths, setDispenseBooths] = useState([]);
  const [portID, setPortID] = useState('');
  const [balancetype, setBalanceType] = useState('');
  const [ipAddress, setIpAddress] = useState();
  const [lCStatus, setLCStatus] = useState(false);
  console.log(setContainerDetails, pastData);
  console.log(containerDetails);
  useEffect(() => {
    handleGetSamplesById();
  }, []);

  useEffect(() => {
    handleGetDispenseBooths();
  }, []);

  const handleGetDispenseBooths = () => {
    dispatch(getAllDispenseBooths()).then((result) => {
      if (result?.payload?.success) {
        let sampling_dispense_booths = result?.payload?.data.filter(
          (data) => data?.bal_type === 'sampling'
        );
        console.log(sampling_dispense_booths, 'sampling_dispense_booths');
        setDispenseBooths(sampling_dispense_booths);
      }
    });
  };

  const handleGetSamplesById = () => {
    const payload = { id: searchParams.get('id') };
    dispatch(getsamples(payload)).then((response) => {
      if (response?.payload?.success) {
        console.log('>>>>>>>>>.', response?.payload?.data);
        setContainerDetails([
          {
            batch_detail: response?.payload?.data?.container?.batch_detail,
            createdAt: response?.payload?.data?.createdAt,
            received_date: response?.payload?.data?.received_date
          }
        ]);
        form.setFieldsValue({
          warehouse_containers: response?.payload?.data?.container?.number,
          quantity: response?.payload?.data?.quantity
            ? parseFloat(
                response?.payload?.data?.uom == `No.'s`
                  ? response?.payload?.data?.quantity
                  : response?.payload?.data?.quantity * 1000
              ).toFixed(3)
            : 'NA',
          retest_date: response?.payload?.data?.retest_date
            ? moment(response?.payload?.data?.retest_date)
            : '',
          ar_number: response?.payload?.data?.batch_detail?.ar_number || 'NA',
          uom: response?.payload?.data?.uom,
          sampling_date: moment(response?.payload?.data?.sampling_date),
          received_date: moment(response?.payload?.data?.received_date)
        });
      }
    });
  };
  const onChange = (value) => {
    console.log(value);
    setContainerChange(true);
    const details = containers.filter(
      (containers) => containers.number === value
    );
    if (details?.[0]?.batch_detail?.lc_status == 'QALC Approved') {
      setContainerDetails(details);
      setLCStatus(
        details?.[0]?.batch_detail?.lc_status == 'QALC Approved' ? true : false
      );
      const payload = { container_id: value };
      dispatch(getPastSamplingDetails(payload)).then((response) => {
        if (response?.payload?.success) {
          setPastData(response?.payload?.data);
        }
      });
    } else {
      setLCStatus(false);
      message.error('Please select a LC approved container');
    }
  };
  console.log(allMaterials);
  console.log(containers);

  const onSearch = (value) => {
    setSearch(value);
    let payload = { search: search };
    search.length > 5
      ? dispatch(getAllContainers(payload)).then((response) => {
          if (response?.payload?.success) {
            setContainers(response?.payload?.data);
          }
        })
      : '';
  };
  const handleQrScan = async (scanData) => {
    if (scanData && scanData !== '') {
      let payload1 = {
        search: scanData.text.slice(scanData.text.lastIndexOf('/') + 1)
      };
      dispatch(getAllContainers(payload1)).then((response) => {
        if (response?.payload?.success) {
          // setContainers(response?.payload?.data);
          const data = response?.payload?.data;
          setContainerDetails(data);
          setContainerChange(true);
          form.setFieldsValue({
            warehouse_containers: scanData.text.slice(
              scanData.text.lastIndexOf('/') + 1
            )
          });
          if (data?.[0]?.batch_detail?.lc_status == 'QALC Approved') {
            setLCStatus(true);
            const payload = {
              container_id: scanData.text.slice(
                scanData.text.lastIndexOf('/') + 1
              )
            };
            dispatch(getPastSamplingDetails(payload)).then((response) => {
              if (response?.payload?.success) {
                setPastData(response?.payload?.data);
              }
            });
          } else {
            setLCStatus(false);
            message.error('Please select a LC approved container');
          }
          setOpenCam(false);
        }
      });
      // const details = containers.filter(
      //   (containers) =>
      //     containers.number ===
      //     scanData.text.slice(scanData.text.lastIndexOf('/') + 1)
      // );
      // console.log(
      //   details,
      //   scanData.text.slice(scanData.text.lastIndexOf('/') + 1),
      //   containers,
      //   'details'
      // );
    }
  };
  const handleError = (err) => {
    console.error(err);
  };

  // Calculate quantity as sum of identification_qty and pooled_qty
  const calculateQuantity = () => {
    const identificationQty =
      parseFloat(form.getFieldValue('identification_qty')) || 0;
    const pooledQty = parseFloat(form.getFieldValue('pooled_qty')) || 0;
    const totalQuantity = identificationQty + pooledQty;
    form.setFieldsValue({ quantity: totalQuantity || '' });
  };

  const handleAddContainer = async () => {
    console.log(form.getFieldValue('warehouse_containers'));

    /*Check : if the container id already exists in samplingData to avoid duplicate*/
    if (
      samplingData?.some(
        (sample) => sample?.container_id === containerDetails[0]?.id
      )
    ) {
      message.error('Container already Added.');
    }

    /*Check : if the container is not selected */
    if (!containerDetails.length > 0) {
      message.error('Please select a container.');
    }

    /* validate the form */
    await form.validateFields();

    /*CHECK : throw Error toaster if the container is selected from different batch */
    if (
      containerDetails[0]?.batch_detail?.inhouse_batch_number &&
      samplingData.length > 0 &&
      samplingData?.some(
        (sample) =>
          sample?.batch_details_id !==
          containerDetails[0]?.batch_detail?.inhouse_batch_number
      )
    ) {
      // error message
      message.error('You cannot add containers from different batches.');
    } else if (
      containerDetails?.length > 0 &&
      !samplingData?.some(
        (sample) => sample?.container_id === containerDetails[0]?.id
      )
    ) {
      console.log('containerDetails>>>>', containerDetails);
      setSamplingData([
        ...samplingData,
        {
          container_id: containerDetails[0]?.id,
          uom: form.getFieldValue('uom'),
          ar_number: containerDetails[0]?.batch_detail?.ar_number,
          identification_qty: form.getFieldValue('identification_qty'),
          pooled_qty: form.getFieldValue('pooled_qty'),
          quantity: form.getFieldValue('quantity'),
          equipment_name: form.getFieldValue('equipment_name'),
          received_date: containerDetails[0]?.createdAt,
          sampling_date: moment().format('YYYY-MM-DD'),
          batch_details_id:
            containerDetails[0]?.batch_detail?.inhouse_batch_number,
          container_num: form.getFieldValue('warehouse_containers'),
          notes: ''
        }
      ]);
      form.resetFields();
    }
  };

  const removeContainer = (index) => {
    console.log('remove', index);
    const newSamplingData = [...samplingData];
    newSamplingData.splice(index, 1);
    setSamplingData(newSamplingData);
  };

  const onSubmit = () => {
    setIsSubmit(true);
    const payload = {
      batch_details_id: containerDetails[0]?.batch_detail?.id,
      samplingData
    };
    dispatch(createSampling(payload)).then((response) => {
      if (response?.payload?.success) {
        setTruckShow(false);
        message.success(response?.payload?.message);
        history.push('/samples-list');
        setIsSubmit(false);
      } else {
        message.error(response?.payload?.message);
        setTruckShow(false);
        setIsSubmit(false);
      }
    });
  };
  const onFinish = (values) => {
    console.log(values?.quantity, 'values?.quantity');
    setTruckShow(true);
    if (containerChange && !searchParams.get('id')) {
      // const payload = {
      //   container_id: containerDetails[0]?.id,
      //   batch_details_id: containerDetails[0]?.batch_detail?.id,
      //   quantity: values?.quantity,
      //   received_date: containerDetails[0]?.createdAt,
      //   ar_number: values?.ar_number,
      //   sampling_date: moment().format('YYYY-MM-DD'),
      //   retest_date: values?.retest_date,
      //   uom: values?.uom
      // };
      const payload = {
        batch_details_id: containerDetails[0]?.batch_detail?.id,
        samplingData
      };
      dispatch(createSampling(payload)).then((response) => {
        if (response?.payload?.success) {
          setTruckShow(false);
          message.success(response?.payload?.message);
          history.push('/samples-list');
        } else {
          setTruckShow(false);
        }
      });
    } else if (searchParams.get('id')) {
      setIsModal(true);
      const payload = {
        container_id: containerDetails[0]?.id,
        batch_details_id: containerDetails[0]?.batch_detail?.id,
        quantity: values?.quantity,
        received_date: containerDetails[0]?.createdAt,
        ar_number: values?.ar_number,
        id: searchParams.get('id'),
        notes: values?.notes,
        uom: values?.uom,
        retest_date: values?.retest_date
      };
      setSampleData(payload);
      // dispatch(updateSampling(payload)).then((response) => {
      //   if (response?.payload?.success) {
      //     setTruckShow(false);
      //     message.success(response?.payload?.message);
      //     history.push('/samples-list');
      //   } else {
      //     setTruckShow(false);
      //   }
      // });
    }
  };

  const handleBalance = (e) => {
    let booth_details = dispenseBooths.filter((item) => item?.ip_address == e);
    setIpAddress(e);
    setPortID(booth_details?.[0]?.port);
    setBalanceType(booth_details?.[0]?.type);
  };

  const handleDispenseBooth = () => {
    const payload = { ip: ipAddress, type: balancetype, port: portID };
    if (payload?.ip) {
      dispatch(getBalance(payload)).then((response) => {
        if (response?.payload?.success) {
          form
            .setFieldsValue(
              'quantity',
              Math.floor(parseFloat(response?.payload?.data) * 1000) / 1000
            )
            .toFixed(3);
        }
      });
      console.log(payload);
    } else {
      message.error('Please select equipment name before you read weight');
    }
  };

  // const handleQA = () => {
  //   setIsModal(true);
  // };

  const columns = [
    {
      title: 'Container Number',
      dataIndex: 'container_num',
      key: 'container_num',
      ellipsis: true,
      width: '100px'
      // render: (_, record) => {
      //   return record?.container?.number ? record?.container?.number : 'NA';
      // }
    },
    {
      title: 'AR Number',
      dataIndex: 'ar_number',
      key: 'ar_number',
      ellipsis: true,
      width: '100px'
    },
    {
      title: 'ID test sample',
      dataIndex: 'identification_qty',
      key: 'identification_qty',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return `${parseFloat(record?.identification_qty).toFixed(3)}` || 'NA';
      }
    },
    {
      title: 'Pooled sample',
      dataIndex: 'pooled_qty',
      key: 'pooled_qty',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return `${parseFloat(record?.pooled_qty).toFixed(3)}` || 'NA';
      }
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return (
          `${parseFloat(record?.quantity).toFixed(3)}${record?.uom}` || 'NA'
        );
      }
    },
    {
      title: 'Batch Number',
      dataIndex: 'batch_details_id',
      key: 'batch_details_id',
      ellipsis: true,
      width: '100px'
    },
    {
      title: 'Sampling Date',
      dataIndex: 'sampling_date',
      key: 'sampling_date',
      ellipsis: true,
      width: '100px',
      render: (text) => {
        return moment(text).format('DD-MM-YYYY');
      }
    },
    {
      title: 'Action',
      dataIndex: 'index',
      key: 'id',
      ellipsis: true,
      width: '100px',
      // render: (_, _, index) => {
      //   return <DeleteOutlined onClick={() => removeContainer(index)} />;
      // }
      render: (text, record, index) => {
        return <DeleteOutlined onClick={() => removeContainer(index)} />;
      }
    }
  ];

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Card
        title={<span>UPDATE SAMPLING WEIGHT DETAILS</span>}
        className={`${styles.cardStyles_approver}`}
        extra={
          user?.level == 3 ? (
            <CustomButton onClick={() => setIsEdit(false)}>
              <EditOutlined />
            </CustomButton>
          ) : (
            ''
          )
        }
      >
        <Row gutter={24}>
          <Col xs={2} xl={2} span={2} md={2} sm={2}>
            <CustomButton
              onClick={() => setOpenCam(true)}
              className={styles.qrcode}
            >
              <QrcodeOutlined onClick={() => setOpenCam(true)} />
            </CustomButton>
          </Col>
          <Col xs={10} xl={6} span={6} md={10} sm={10}>
            <FormItem
              name="warehouse_containers"
              label="Warehouse Containers"
              rules={[
                {
                  required: false,
                  message: 'Enter warehouse containers'
                }
              ]}
              className={styles.customLable}
            >
              <Select
                showSearch
                placeholder="Scan or select container"
                optionFilterProp="children"
                onChange={onChange}
                onSearch={onSearch}
                disabled={searchParams.get('id') ? true : false}
              >
                {containers?.map((item, index) => {
                  return containers ? (
                    <option value={item.number} key={index}>
                      {item.number}
                    </option>
                  ) : (
                    <Spin />
                  );
                })}
              </Select>
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="AR Number"
              // name="ar_number"
              rules={[
                {
                  required: false,
                  message: 'Enter AR Number'
                }
              ]}
              className={styles.customLable}
            >
              <Input
                value={
                  searchParams.get('id') !== ''
                    ? containerDetails[0]?.batch_detail?.ar_number
                    : containerDetails[0]?.batch_detail?.ar_number || 'NA'
                }
                disabled
              />
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="Material Code"
              rules={[
                {
                  required: true,
                  message: 'Select Material Code'
                }
              ]}
              className={styles.customLable}
            >
              <Input
                disabled
                value={
                  searchParams.get('id') !== ''
                    ? containerDetails[0]?.batch_detail?.material?.code
                    : containerDetails[0]?.batch_detail?.material?.code || 'NA'
                }
              />
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="Material Name"
              rules={[
                {
                  required: false,
                  message: 'Select Material Code'
                }
              ]}
              className={styles.customLable}
            >
              <Input
                value={`${
                  searchParams.get('id')
                    ? containerDetails[0]?.batch_detail?.material?.name
                    : containerDetails[0]?.batch_detail?.material?.name || 'NA'
                }`}
                disabled
              />
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="Batch Number"
              rules={[
                {
                  required: false,
                  message: 'Select Material Code'
                }
              ]}
              className={styles.customLable}
            >
              <Input
                value={
                  searchParams.get('id') !== ''
                    ? containerDetails[0]?.batch_detail?.inhouse_batch_number
                    : containerDetails[0]?.batch_detail?.inhouse_batch_number ||
                      'NA'
                }
                disabled
              />
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="Received Date"
              rules={[
                {
                  required: false,
                  message: 'Select Material Code'
                }
              ]}
              className={styles.customLable}
            >
              <Input
                value={`${
                  containerDetails[0]?.received_date
                    ? moment(containerDetails[0]?.received_date).format(
                        'DD-MMM-YYYY'
                      )
                    : 'NA'
                }`}
                disabled
              />
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12}>
            <FormItem
              label="Equipment Name"
              name="equipment_name"
              className={styles.customLable}
              rules={[
                {
                  required: true,
                  message: 'Please select the equipment name'
                }
              ]}
            >
              <Select
                placeholder="Select Balance Name"
                onChange={(e) => handleBalance(e)}
              >
                {dispenseBooths?.map((item, index) => {
                  return (
                    <option value={item?.ip_address} key={index}>
                      {item?.dispense_booth_id}
                    </option>
                  );
                })}
              </Select>
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="ID test sample"
              name="identification_qty"
              rules={[
                {
                  required: true,
                  message: 'Enter Identification test sample'
                }
              ]}
              className={styles.customLable}
            >
              <Input
                placeholder="Enter Identification test sample"
                onChange={calculateQuantity}
              />
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="Pooled sample"
              name="pooled_qty"
              rules={[
                {
                  required: true,
                  message: 'Enter pooled sample'
                }
              ]}
              className={styles.customLable}
            >
              <Input
                placeholder="Enter pooled sample"
                onChange={calculateQuantity}
              />
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="Quantity"
              name="quantity"
              rules={[
                {
                  required: true,
                  message: 'Enter Quantity'
                }
              ]}
              className={styles.customLable}
            >
              <Input placeholder="Enter Quantity" disabled />
            </FormItem>
            <CustomButton
              style={{
                color: '#c91761',
                marginTop: '-16px'
              }}
              size="small"
              onClick={() => handleDispenseBooth()}
            >
              Read
            </CustomButton>
            {/* <FormItem
              label="Quantity"
              name="quantity"
              rules={[
                {
                  required: false,
                  message: 'Select Material Code'
                }
              ]}
              className={styles.customLable}
            >
              <Input
                placeholder="Enter Quantity"
                disabled={searchParams.get('id') ? isEdit : false}
              />
              <CustomButton
                style={{
                  color: '#c91761',
                  marginTop: '2px'
                }}
                size="small"
                onClick={() => handleDispenseBooth()}
              >
                Read
              </CustomButton>
            </FormItem> */}
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="UOM"
              rules={[
                {
                  required: true,
                  message: 'Select Material Code'
                }
              ]}
              className={styles.customLable}
              name="uom"
            >
              <Select
                showSearch
                placeholder="Select UOM"
                optionFilterProp="children"
                disabled={searchParams.get('id') ? true : false}
              >
                <option value="Grams">Grams</option>
                <option value="ml">Milliliters(ML)</option>
                <option value="No.'s">{`No.'s`}</option>
              </Select>
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={12} md={24} sm={24}>
            <FormItem
              label="Sampling Date"
              name="sampling_date"
              rules={[
                {
                  required: false,
                  message: 'Select Sampling Date'
                }
              ]}
              className={styles.customLable}
            >
              <DatePicker
                defaultValue={moment()}
                format={dateFormat}
                style={{ width: '100%' }}
                disabled
              />
            </FormItem>
          </Col>
          {searchParams.get('id') ? (
            <Col xs={24} xl={24} span={24} md={24} sm={24}>
              <FormItem
                label="Comments"
                name="notes"
                rules={[
                  {
                    required: false,
                    message: 'Enter Ntes'
                  }
                ]}
                className={styles.customLable}
              >
                <TextArea
                  value={
                    searchParams.get('id')
                      ? containerDetails[0]?.batch_detail?.notes
                      : ''
                  }
                  rows={4}
                  disabled={searchParams.get('id') ? isEdit : false}
                />
              </FormItem>
            </Col>
          ) : (
            ''
          )}
        </Row>
        <br />
        <FormItem className="text-center">
          {searchParams.get('id') && !isEdit ? (
            <CustomButton
              className={styles.inwardButton}
              htmlType="submit"
              // onClick={() => handleQA()}
              type="primary"
            >
              Initiate Verification
            </CustomButton>
          ) : (
            ''
          )}
          {!searchParams.get('id') ? (
            truckShow ? (
              <Image
                src={truck}
                preview={false}
                style={{ width: '100px !important', height: '100px' }}
              />
            ) : (
              <CustomButton
                className={styles.inwardButton}
                // htmlType="submit"
                onClick={handleAddContainer}
                type="primary"
                disabled={!lCStatus}
              >
                Next
              </CustomButton>
            )
          ) : (
            ''
          )}
        </FormItem>
      </Card>
      {openCam ? (
        <QrReader
          constraints={{ facingMode: 'environment' }}
          delay={1000}
          onError={handleError}
          onResult={(result) => handleQrScan(result)}
          // chooseDeviceId={()=>selected}
          style={{ width: '3px', height: '3px' }}
        />
      ) : (
        ''
      )}
      <Card
        title={<span>Sampling Details</span>}
        className={`${styles.cardStyles_approver}`}
      >
        <div className={`${styles.table_container}`}>
          <CustomTable
            columns={columns}
            pagination={false}
            scroll={{ x: 'auto' }}
            // dataSource={pastData}
            dataSource={samplingData}
            rowKey="id"
          />
        </div>
      </Card>
      <br />
      <FormItem className="text-center">
        <Space>
          {' '}
          <CustomButton
            className={styles.inwardButton}
            onClick={() => history.back()}
            type="primary"
          >
            Back to Home
          </CustomButton>
          {isSubmit ? (
            <Spin size="large" />
          ) : (
            <CustomButton
              className={styles.inwardButton}
              // htmlType="submit"
              type="primary"
              onClick={onSubmit}
            >
              Submit
            </CustomButton>
          )}
        </Space>
      </FormItem>
      {isModal ? (
        <VerificationModal
          isModal={isModal}
          materials={sampleData}
          setIsModal={setIsModal}
          setIsEdit={setIsEdit}
          page="sampling"
        />
      ) : (
        ''
      )}
    </Form>
  );
};
export default SamplingMaterialsPage;
